// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__+KJLy","logoContainer":"Header_logoContainer__tg0-i","logo":"Header_logo__nZ7K6"};